import React, { CSSProperties, FC } from 'react'

import cn from 'clsx'

import { TourPage } from '../ProductTourModal.types'
import { TourNavigationButton } from '../TourNavigationButton'
import styles from './PageNavigation.module.scss'
import { PageNavigationProps } from './PageNavigation.types'

const PAGE_CONFIG: Array<{
  number: number
  id: TourPage
}> = [
  {
    number: 1,
    id: 'interconnected-apps'
  },
  {
    number: 2,
    id: 'all-apps'
  },
  {
    number: 3,
    id: 'shortcuts'
  }
]

export const PageNavigation: FC<PageNavigationProps> = ({
  currentPage,
  buttonLabel,
  setActivePage,
  onNavigate,
  animationDelay
}) => {
  const getPageForNumber = (number: number): TourPage => {
    const page = PAGE_CONFIG.find(page => page.number === number)
    return page?.id || PAGE_CONFIG[0].id
  }

  return (
    <div
      className={styles.pageNavigation}
      style={
        {
          '--animation-delay': `${animationDelay}s`
        } as CSSProperties
      }
    >
      <TourNavigationButton
        label={buttonLabel}
        onClick={() => {
          if (onNavigate) {
            onNavigate()
            return
          }
          setActivePage(getPageForNumber(currentPage + 1))
        }}
      />
      <div className={styles.pages}>
        {[
          ...Array.from({
            length: PAGE_CONFIG.length
          })
        ].map((_, i) => (
          <div
            className={cn(styles.page, {
              [styles.active]: currentPage === i + 1
            })}
            role='button'
            onClick={() => {
              setActivePage(getPageForNumber(i + 1))
            }}
            key={`navigation-page-${i}`}
          />
        ))}
      </div>
    </div>
  )
}
